<template>
    <div v-if="checkAppsAllowed('active-offer') || checkMenuAllowed('clientes') || checkMenuAllowed('tarefas') || checkMenuAllowed('reservas') || checkAppsAllowed('simulator') || checkMenuAllowed('propostas')" class="shortcuts-menu">
        <div class="text">O que você deseja fazer?</div>
        <button type="button" :class="status ? 'active' : ''" @click="toggle" v-html="content" />
        <section v-if="status" class="options" @mouseleave="close">
            <ul>
                <li v-if="checkAppsAllowed('active-offer')" @click="menuClickEvent('active-offer')">
                    <a href="#" @click="openActiveOffer">
                        <div>Oferta Ativa</div>
                    </a>
                </li>
                <!-- <li v-if="checkMenuAllowed('clientes')">
                    <a :href="oldPanelLink('guia/deal')" @click="menuClickEvent('clientes')">
                        <div>Cadastrar um Cliente</div>
                    </a>
                </li> -->
                <li v-if="checkMenuAllowed('clientes')">
                    <a href="#" @click="openCreateDealModal">
                        <div>Cadastrar um Cliente</div>
                        <!-- <span>Beta</span> -->
                    </a>
                </li>
                <li v-if="checkMenuAllowed('tarefas')">
                    <a href="#" @click="openNewTask">
                        <div>Criar uma Tarefa</div>
                    </a>
                </li>
                <li v-if="checkMenuAllowed('reservas')">
                    <a href="#" @click="openRequestReserve">
                        <div>Solicitar uma Reserva</div>
                    </a>
                </li>
                <li v-if="checkAppsAllowed('simulator')">
                    <router-link to="/vendas/simulacao" @click="menuClickEvent('simulator')">
                        <div>{{ simulationMenuLabelComputed }}</div>
                    </router-link>
                </li>
                <li v-if="checkMenuAllowed('propostas')">
                    <a href="#" @click="openCreateProposalModal">
                        <!-- <div>{{ proposalMenuLabelComputed }} <span class="new">Novo</span></div> -->
                        <div>{{ proposalMenuLabelComputed }} </div>
                    </a>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
    import helpers from '@/mixins/helpers'
    import { storage } from '@/services/storage'

	export default {
        name: 'fast-menu',
        mixins: [ helpers ],
        props: {
            content: {
                type: String,
                default: ''
            }
        },
        data(){
            return {
                status: false,
                allowedApps: null,
                allowedMenu: null,
                proposalSettings: null
            }
        },

        computed: {
            proposalMenuLabelComputed() {
                return this.proposalSettings &&
                    this.proposalSettings.proposal &&
                    this.proposalSettings.proposal.menu_name
                    ? this.proposalSettings.proposal.menu_name
                    : 'Preencher Proposta'
            },
            simulationMenuLabelComputed() {
                return this.proposalSettings &&
                    this.proposalSettings.simulation &&
                    this.proposalSettings.simulation.menu_name
                    ? this.proposalSettings.simulation.menu_name
                    : 'Simular Proposta'
            }
        },

        created(){
            this.allowedApps = storage.get('allowed_apps')
            this.allowedMenu = storage.get('allowed_menu')
            this.proposalSettings = storage.get('proposal_settings')
                ? JSON.parse(storage.get('proposal_settings'))
                : null

            this.$root.$on('fast-menu', () => {
                this.close()
            })
        },

        beforeDestroy() {
            this.$root.$off('fast-menu')
        },

        methods: {
            toggle(){
                this.status = !this.status
                this.$root.$emit('notifications')
            },
            close(){
                this.status = false
            },
            checkAppsAllowed(name){
                return this.allowedApps.includes(name)
            },
            checkMenuAllowed(name){
                return this.allowedMenu.includes(name)
            },
            /**
             * Abre o modal de oferta ativa
             */
            openActiveOffer() {
                this.$root.$emit('modal-open-active-offer')
            },
			/**
             * Abre o modal de tarefas
             */
            openNewTask () {
                this.$root.$emit('modal-open-global--create-task', false, true)
                this.menuClickEvent('tarefas')
            },
            /**
             * Abre o modal de reservas
             */
			openRequestReserve() {
				this.$root.$emit('modal-open-global--request-reserve')
                this.menuClickEvent('reservas')
			},

			openCreateDealModal(){
				this.$root.$emit('modal-open-create-deal-modal')
                this.$root.$emit('create-proposal-modal', false)
			},
            openCreateProposalModal() {
                this.$root.$emit('modal-open-create-deal-modal', 'createProposal', true)
            },
            /**
             * Emite um evento para o Google Analytics acerca do menu rápido acessado
             */
            menuClickEvent(menu) {
                let event = null
                switch (menu) {
                    case 'clientes':
                        event = {
                            event: "fac_button_click",
                            category: "vuejs-criar cliente",
                            action: "click",
                            label: "Criar cliente a partir do botão na home"
                        }
                        break

                    case 'tarefas':
                        event = {
                            event: "fac_button_click",
                            category: "vuejs-criar tarefa",
                            action: "click",
                            label: "Criar tarefa a partir do botão na home"
                        }
                        break

                    case 'reservas':
                        event = {
                            event: "fac_button_click",
                            category: "vuejs-criar reserva",
                            action: "click",
                            label: "Criar reserva a partir do botão na home"
                        }
                        break

                    case 'simulator':
                        event = {
                            event: "fac_button_click",
                            category: "vuejs-simular proposta",
                            action: "click",
                            label: "Simular proposta a partir do botão na home"
                        }
                        break

                    case 'active-offer':
                        event = {
                            event: "fac_button_click",
                            category: "Oferta Ativa",
                            action: "click",
                            label: "Abrir as ofertas ativas a partir do botão na home"
                        }
                        break

                    case 'propostas':
                        event = {
                            event: "fac_button_click",
                            category: "Criar Proposta",
                            action: "click",
                            label: "Abrir guia de proposta a partir do botão na home"
                        }
                        break
                }

                if (event) this.$gtm.trackEvent(event)
            }
        }
    };
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
